import React from 'react'
import { ConfirmationRoleAction } from '../../../legacy-design-system/action'
import { ResetDialog } from './reset-dialog'
import { ApplicationActionProps } from './row-action-list'
import { IconReset } from '@contrast-security-inc/design-system-foundations'
import { ConfirmationRoleActionProps } from '../../../legacy-design-system/action/confirmation-role-action'

export function ResetAction(
  props: ApplicationActionProps & Pick<ConfirmationRoleActionProps, 'size'>
) {
  return (
    <ConfirmationRoleAction
      size={props.size}
      data-testid="action_applications_reset_application"
      isActionValid={!props.isFreemium && !props.application.archived}
      role={props.application.role}
      requiredRole="ADMIN"
      icon={IconReset}
      iconTooltipMessage={{
        id: 'action_applications_reset_application',
        defaultMessage: 'Reset'
      }}
      renderDialog={(renderDialogProps) => {
        return <ResetDialog {...props} {...renderDialogProps} />
      }}
      iconTooltipPlacement="top"
    />
  )
}
